import { Download, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useExportJobs } from '@/hooks/useExportJobs';
import { useToast } from '@/hooks/use-toast';

interface JobsExportButtonProps {
  isVendor: boolean;
}

export function JobsExportButton({ isVendor }: JobsExportButtonProps) {
  const { exportJobs, isExporting, error } = useExportJobs();
  const { toast } = useToast();

  const handleExport = async () => {
    const success = await exportJobs(isVendor);
    
    if (success) {
      toast({
        title: 'Export Complete',
        description: 'Your jobs have been exported to CSV.',
      });
    } else if (error) {
      toast({
        title: 'Export Failed',
        description: error,
        variant: 'destructive',
      });
    }
  };

  return (
    <Button
      variant="outline"
      onClick={handleExport}
      disabled={isExporting}
      aria-label="Export all jobs to CSV"
    >
      {isExporting ? (
        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
      ) : (
        <Download className="mr-2 h-4 w-4" />
      )}
      Export All Jobs
    </Button>
  );
}
